import { Box } from "@mui/material";
import * as React from "react";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { ConfirmationDialogResult, DefaultHandlerType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../../framework/appUtils";
import { SaveDataObj } from "../../../../framework/saveData";
import { IUnitDefaultHandlersNode } from "../../../../models/unit/unitDefaultHandlersNode";
import { UserListItems } from "../../../../models/user/userListItems";
import { ConfirmationButton } from "../../../framework/Button/ConfirmationButton";
import { UnitDefaultHandlers } from "../UnitDefaultHandlers";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";

export interface IUnitDefaultHandlersSettingsProp {
    classes?: string;
    infoText?: string;
    companyId: string;
    showHandlerTypes?: boolean;
    unitNode: IUnitDefaultHandlersNode;
    onSave: (obj: any) => Promise<ApiSuccess>;
    onOk: () => void;
    onCancel: (closeDialog: boolean) => void;
    onGetUserSelectListItems?: (companyId: string, unitId: string, handlerType: DefaultHandlerType, pageSize: number, page: number, filter: string,
        ignoreUserIds: string[], ignoreUserCodes: string[], activityState: number, ignoreRecordUserConnected: boolean,
        doNotIgnoreRecordUserConnectedUserCode: string, sortColumn: string, sortOrderIsAsc: boolean) => Promise<UserListItems>;
}

export interface IUnitDefaultHandlersSettingsState {
    saveUnitNode: IUnitDefaultHandlersNode;
}

export class UnitDefaultHandlersSettings extends React.Component<IUnitDefaultHandlersSettingsProp, IUnitDefaultHandlersSettingsState> {
    private orgStateHash: string = "";

    constructor(props: IUnitDefaultHandlersSettingsProp) {
        super(props);
        this.state = {
            saveUnitNode: props.unitNode
        };
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    handleChangeSaveUnitNode = (saveUnitNode: IUnitDefaultHandlersNode) => {
        this.setState({
            saveUnitNode
        });
    };

    getSaveDataFromState = (props: IUnitDefaultHandlersSettingsProp, state: IUnitDefaultHandlersSettingsState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("companyId", props.companyId);
        result.append("handlers", state.saveUnitNode?.getUnitDefaultHandlersNodeSaves([]));
        return result;
    };

    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        const saveData = this.getSaveDataFromState(props, state);
        //Call server
        const result = await AppUtils.callService(() => props.onSave(saveData.obj));
        if (!result) return;
        // Save new hash since the window stays open in some scenarios
        this.orgStateHash = saveData.hash;
        props.onOk();
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async (closeDialog: boolean) => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash, null);
        if (cancelResult === ConfirmationDialogResult.Cancel) return false;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            await this.saveToDb();
        } else {
            props.onCancel(closeDialog);
        }

        return true;
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Box display="flex" flexDirection="column" flexGrow={2} justifyContent="space-between">
                <UnitDefaultHandlers
                    infoText={props.infoText}
                    companyId={props.companyId}
                    showHandlerTypes={props.showHandlerTypes}
                    unitId={props.unitNode.id}
                    unitNode={props.unitNode}
                    partnerCompanyIds={props.unitNode.partnerCompanyIds}
                    onChangeSaveUnitNode={this.handleChangeSaveUnitNode}
                    onGetUserSelectListItems={props.onGetUserSelectListItems}
                />
                <Box display="flex" alignItems="centre" justifyContent="flex-end">
                    <AppButton variant="outlined" onClick={() => this.handleCancel(true)} sx={{ marginRight: ".5rem" }}>{Translations.Close}</AppButton>
                    <ConfirmationButton onClick={this.handleSave} disabled={this.getSaveDataFromState(props, state).hash === this.orgStateHash}>{Translations.Save}</ConfirmationButton>
                </Box>
            </Box>
        );
    }
}